import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './Header.css';


const Header = () => {
    // const navigate = useNavigate();
    const [navbar, setNavbar] = useState(false);

    const menuItems = <React.Fragment>
        <ul className="items-center justify-center space-y-8 md:flex md:space-x-6 md:space-y-0">
            <li className="text-xl text-[#878E99] relative w-max one">
                <NavLink className='text-[#D2E6EA] hover:text-[#ff014f] cursor-pointer' to='/'> Home </NavLink>
                <span className="absolute -bottom-1 left-0 w-0 transition-all h-[1px] bg-[#ff014f]"></span>
            </li>
            <li className="text-xl text-[#878E99] relative w-max one">
                <NavLink className='text-[#D2E6EA] hover:text-[#ff014f] cursor-pointer' to='/about-us'> About Us </NavLink>
                <span className="absolute -bottom-1 left-0 w-0 transition-all h-[1px] bg-[#ff014f]"></span>
            </li>
            <li className="text-xl text-[#878E99] relative w-max one">
                <NavLink className='text-[#D2E6EA] hover:text-[#ff014f] cursor-pointer' to='/services'>Services </NavLink>
                <span className="absolute -bottom-1 left-0 w-0 transition-all h-[1px] bg-[#ff014f]"></span>
            </li>
            <li className="text-xl text-[#878E99] relative w-max one">
                <NavLink className='text-[#D2E6EA] hover:text-[#ff014f] cursor-pointer' to='/blogs'> Blog </NavLink>
                <span className="absolute -bottom-1 left-0 w-0 transition-all h-[1px] bg-[#ff014f]"></span>
            </li>
            <li className="text-xl text-[#878E99] relative w-max one">
                <NavLink className='text-[#D2E6EA] hover:text-[#ff014f] cursor-pointer' to='/contact'> Contact </NavLink>
                <span className="absolute -bottom-1 left-0 w-0 transition-all h-[1px] bg-[#ff014f]"></span>
            </li>
        </ul>
    </React.Fragment>

    return (
        <div className='sticky top-0 z-[9999] w-full'>
            <nav className="w-full bg-[#212428] shadow border-b-2 border-black">
                <div className="justify-between px-4 mx-auto max-w-7xl items-center md:flex">

                    <div className="flex items-center justify-between py-3 ">
                        <NavLink to='/'>
                            <div className='flex items-center gap-3'>
                                <div className="avatar">
                                    <div className="w-16 rounded-full ring ring-[#4E545B] ring-offset-base-100 ring-offset-2">
                                        <img src='https://i.ibb.co/dD7d8Kj/shijan.jpg' alt='phot' />
                                    </div>
                                </div>
                                <div>
                                    <h2 className='text-3xl text-[#BBC6D4] font-bold'>My Portfolio</h2>
                                </div>
                            </div>
                        </NavLink>
                        <div className="md:hidden">
                            <button
                                className="p-2 text-gray-700 rounded-md outline-none focus:border-gray-400 focus:border"
                                onClick={() => setNavbar(!navbar)}
                            >
                                {navbar ? (
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="w-6 h-6 text-white"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                            clipRule="evenodd"
                                        />
                                    </svg>
                                ) : (
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="w-10 h-10 text-white"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                        strokeWidth={2}
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M4 6h16M4 12h16M4 18h16"
                                        />
                                    </svg>
                                )}
                            </button>
                        </div>
                    </div>
                    <div>
                        <div
                            className={`flex-1 justify-self-center pb-3 mt-8 md:block md:pb-0 md:mt-0 ${ navbar ? "block" : "hidden"
                                }`}
                        >
                            {menuItems}

                        </div>
                    </div >
                </div>
            </nav >
        </div>
    );
};

export default Header;